import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { AuthProvider } from './services/authentication/authContext';
import { initPostHog } from './services/analytics/posthogService';
import { installImpersonationFetchInterceptor } from './services/impersonation/fetchInterceptor';

// Append the super-admin impersonation header to API calls when active
installImpersonationFetchInterceptor();

// Initialize PostHog analytics
initPostHog();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
